import request from '@/utils/request'

// 查询客户模组清单
export function findModules(params) {
  return request({
    url: `/customer/modules`,
    method: 'get',
    params
  })
}
